import React from 'react';
import { Typography, Box, Button, Avatar, Container } from '@mui/material';
import { keyframes } from '@emotion/react';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';

// Enhanced Animation for "FRONTEND DEVELOPER"
const typing = keyframes`
  0% { width: 0; }
  50% { width: 100%; }
  55% { width: 100%; } /* Pause at full width */
  100% { width: 0; }
`;

const blink = keyframes`
  50% { border-color: transparent; }
`;

const Home = () => {
  return (
    <Container
      sx={{
        mt: 4,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        color: '#6E7A90',
        gap: 4,
      }}
    >
      {/* Left-side Text Content */}
      <Box sx={{ maxWidth: { xs: '100%', md: '50%' } }}>
        {/* Intro Text */}
        <Typography
          variant="h4"
          sx={{  mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          Hello It's Me
        </Typography>

        {/* Name */}
        <Typography
          variant="h5"
          sx={{ fontWeight: 'bold',fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2, color: '#515669' }}
        >
          NELVIESH WILLSON
        </Typography>

        {/* Animated "FRONTEND DEVELOPER" */}
        <Typography
  variant="h6"
  sx={{
    fontSize: { xs: '1.5rem', md: '2rem' },
    color: 'gold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'inline-block', // Ensures the width adjusts to the content
    animation: `${typing} 5s steps(22) infinite, ${blink} 0.5s step-end infinite`,
    animationTimingFunction: 'linear',
    fontFamily: 'Inter, sans-serif',
  }}
>
  FRONTEND DEVELOPER
</Typography>




        {/* Small Intro */}
        <Typography
          variant="body1"
          sx={{
            color: '#6E7A90',
            mb: 2,
            fontSize: { xs: '0.9rem', md: '1rem' },
            maxWidth: '600px',
          }}
        >
          Crafting user-friendly web applications with responsive designs and modern technologies.
        </Typography>

        {/* Social Media Links */}
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <LinkedInIcon
            sx={{
              fontSize: 30,
              cursor: 'pointer',
              color: '#6E7A90',
              '&:hover': { opacity: 0.8 },
            }}
            onClick={() =>
              window.open(
                'https://www.linkedin.com/in/nelviesh-willson-65abn?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
                '_blank'
              )
            }
          />
          <GitHubIcon
            sx={{
              fontSize: 30,
              cursor: 'pointer',
              color: '#6E7A90',
              '&:hover': { opacity: 0.8 },
            }}
            onClick={() => window.open('https://github.com/Nelviesh', '_blank')}
          />
          <InstagramIcon
            sx={{
              fontSize: 30,
              cursor: 'pointer',
              color: '#6E7A90',
              '&:hover': { opacity: 0.8 },
            }}
            onClick={() =>
              window.open(
                'https://www.instagram.com/beaconbin.2004?igsh=YjRvMG94Z2Uwb2lp',
                '_blank'
              )
            }
          />
        </Box>

        {/* Download CV Button */}
        <Button
          variant="contained"
          sx={{
            mt: 3,
            backgroundColor: '#6E7A90',
            color: '#FFFFFF',
            '&:hover': { backgroundColor: '#8893A7' },
          }}
          onClick={() =>
            window.open(
              'https://drive.google.com/file/d/1w9XZx815G8lX7Si-xtfVYsy8HszBOZMB/view?usp=sharing',
              '_blank'
            )
          }
        >
          Download CV
        </Button>
      </Box>

      {/* Right-side Image */}
      <Box
        sx={{
          maxWidth: { xs: '100%', md: '45%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Avatar
          variant="circular"
          src={`${process.env.PUBLIC_URL}/my-photo.jpg`}
          alt="Profile Photo"
          sx={{
            width: { xs: '200px', md: '300px' }, // Adjust width as needed
            height: { xs: '200px', md: '300px' }, // Ensure circular dimensions
            borderRadius: '50%',
            boxShadow: '10px 10px 25px rgba(0, 0, 0, 0.3)',
          }}
        />
      </Box>
    </Container>
  );
};

export default Home;
